import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBatteryFull"><Path d="M19.25 15.25V8.75M19.25 15.25C19.25 16.9069 17.9069 18.25 16.25 18.25H4.75C3.09315 18.25 1.75 16.9069 1.75 15.25V8.75C1.75 7.09315 3.09315 5.75 4.75 5.75H16.25C17.9069 5.75 19.25 7.09315 19.25 8.75M19.25 15.25H20.75C21.5784 15.25 22.25 14.5784 22.25 13.75V10.25C22.25 9.42157 21.5784 8.75 20.75 8.75H19.25M6 9.75V14.25M10.5 9.75V14.25M15 9.75V14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBatteryFull;
